// extracted by mini-css-extract-plugin
export default {"header":"Header_header__MY7fH","spacer":"Header_spacer__f6hCB","container":"Header_container__HeoAl"};